import Vue from 'vue'
import App from './App.vue'
import awsconfig from './aws-exports-config'
import { Auth, Amplify } from 'aws-amplify'
import router from './router'
import './registerServiceWorker'
import ArgonDashboard from './plugins/argon-dashboard'
import { store } from './store/store'
import IdleVue from "idle-vue"
const eventsHub = new Vue()
Vue.config.productionTip = false
Amplify.configure(awsconfig)
Auth.configure({ storage: window.sessionStorage })
Vue.use(ArgonDashboard)

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1000 * 60 * 60,
  startAtIdle: false
});

Vue.config.ignoredElements = [
  'stream-config-page'
];

new Vue({
  router,
  store: store,
  render: h => h(App)
}).$mount('#app')
